<div *ngIf="localeTexts.length" class="row" [attr.data-locale]="currentLocale" style="position: relative;">
    <!-- <div class="row close-model" (click)="closeModal()">
        <button class="close-button" tabindex="0" aria-label="Close My Bookings">
            <i class="material-icons">close</i>
        </button>
    </div> -->
    <div *ngIf="hideSignupTab && !isLoggedIn" class="row header-login-text">
        <span>{{localeTexts[3].manageBookingPanel[0].headline}}</span>
    </div>
</div>

<div *ngIf="isLoggedIn && localeTexts.length" [attr.data-locale]="currentLocale">

    <mat-nav-list class="bigmember-text">
        <div class="row s12 m12 l12 bigmember">
            <div class="col s5 m5 l4">
                <span>{{localeTexts[0].main.bigMemberID}}</span>
            </div>
            <div class="col s7 m7 l8">
                <span>{{bigMember}}</span>
            </div>
        </div>
        <div class="row bigmember">
            <div class="col s5 m5 l4">
                <span>{{localeTexts[0].main.bigPoints}}</span>
            </div>
            <div class="col s7 m7 l8">
                <span>{{bigPointsBalance}}</span>
                <span>
                    <img class="refresh-icon" src="https://b.staticaa.com/images/misc/refresh-icon.png" alt="refresh icon" (click)="refreshBigPoints(true)">
                </span>
            </div>
        </div>
        <div class="row bigmember">
            <div class="col s5 m5 l4">
                <span>{{localeTexts[0].main.status}}</span>
            </div>
            <div class="col s7 m7 l8">
                <img src="{{bigStatusImgUrl}}" alt="status">
            </div>
        </div>

    </mat-nav-list>
    <hr class="hr-color">
    <mat-nav-list class="">
        <div *ngFor="let item of localeTexts[4].mainNav[0].content; let i = index">
            <a mat-list-item>
                <span>
                    <a href="{{item.url}}" target="{{item.newTab == 'TRUE' ? '_blank' : ''}}">
                        <div class="row row-width">
                            <div class="col icon-col">
                                <mat-icon class="icon-color">{{item.icon}}</mat-icon>
                            </div>
                            <div class="col icon-des">
                                <span class="text-size">{{item.text}}</span>
                            </div>
                        </div>
                    </a>
                </span>
            </a>
        </div>
    </mat-nav-list>

    <hr class="hr-color">
    <div class="logout">
        <div>
            <span class="text-size logtext" (click)="signOut(true)">{{localeTexts[0].main.logout}}</span>
        </div>
    </div>

</div>

<div *ngIf="localeTexts.length && !hideSignupTab && !isLoggedIn" class="row widget-footer" [attr.data-locale]="currentLocale">
    <div class="row text-diff">
        <span class="agent-text">{{localeTexts[1].mainNav[0].headline}}</span>
    </div>
    <div class="row">
        <div class="loginFooter-content" *ngFor="let item of localeTexts[1].mainNav[1].content">
            <a href="{{item.url}}" target="{{item.newTab == 'TRUE' ? '_blank' : ''}}">
                <span class="footerend-text">{{item.text}}</span>
            </a>
        </div>
    </div>
</div>


<div *ngIf="localeTexts.length && hideSignupTab && !isLoggedIn" class="row widget-login-footer" [attr.data-locale]="currentLocale">
    <div class="col s12 m12 l8 pur-btn">
        <span class="login-widget-text">{{localeTexts[3].manageBookingPanel[1].content[0].text}}</span>
    </div>
    <div class="col s12 m12 l4 pur-btn">
        <button class="btn" (click)="openPurchaseNow(localeTexts[3].manageBookingPanel[2].button[0].url, localeTexts[3].manageBookingPanel[2].button[0].newTab)">
            {{localeTexts[3].manageBookingPanel[2].button[0].text}}
        </button>
    </div>
</div>